import qs from 'qs'
import {TokenKeys} from '@/common/js/variable'
import {Toast} from 'cube-ui'
//表情转换编码
export  function utf16toEntities(str) {
  if (!str) {
    return str
  }
  var patt = /[\ud800-\udbff][\udc00-\udfff]/g;
  // 检测utf16字符正则
  str = str.replace(patt, function (char) {
    var H, L, code;
    if (char.length === 2) {
      H = char.charCodeAt(0);
      // 取出高位
      L = char.charCodeAt(1);
      // 取出低位
      code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00;
      // 转换算法
      return "&#" + code + ";";
    } else {
      return char;
    }
  });
  return str;
};
//表情转换解码
export function entitiestoUtf16(str) {
  if (!str) {
    return ''
  }
  // 检测出形如&#12345;形式的字符串
  var strObj = utf16toEntities(str);
  var patt = /&#\d+;/g;
  var H, L, code;
  var arr = strObj.match(patt) || [];
  for (var i = 0; i < arr.length; i++) {
    code = arr[i];
    code = code.replace('&#', '').replace(';', '');
    // 高位
    H = Math.floor((code - 0x10000) / 0x400) + 0xD800;
    // 低位
    L = (code - 0x10000) % 0x400 + 0xDC00;
    code = "&#" + code + ";";
    var s = String.fromCharCode(H, L);
    strObj = strObj.replace(code, s);
  }
  return strObj;
};
export  function getHtmlData(str) {
  if (!str) {
    return '';
  }
  let newStr = entitiestoUtf16(str).replace('<', '&lt;').replace('>', '&gt;').replace(/\n|\r\n/g, "<br>").replace(/[ ]/g, "&nbsp;");
  return newStr;
};
export function getType(obj) {
  let toString = Object.prototype.toString;
  let map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
};
export function getQsParse(str){
  let strs=getType(str)=='string'?str:location.href.split('?')[1];
  return qs.parse(strs);
}


export function getQsString(obj){
  let objs=getType(obj)=='object'?obj:{};
  return qs.stringify(objs);
};
export function deepClone(data) {
  let type = getType(data);
  let obj;
  if (type === 'array') {
    obj = [];
  } else if (type === 'object') {
    obj = {};
  } else {
    return data;
  }
  if (type === 'array') {
    for (let i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]));
    }
  } else if (type === 'object') {
    for (let key in data) {
      obj[key] = deepClone(data[key]);
    }
  }
  return obj;
};
export function sort (a, b){
  if (a > b) {
    return 1
  } else if (a < b) {
    return -1
  } else {
    return 0
  }
};
//验证手机号
export function checkPhone (mobile) {
  let reg = /(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$)|(^((\(\d{3}\))|(\d{3}\-))?(1[3456789]\d{9})$)/;
  return reg.test(mobile)
};
export function checkExpression(str) {
  let emoji=/[\ud800-\udbff][\udc00-\udfff]/;
  let reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]");
  if((!str)||reg.test(str)||emoji.test(str)||(str.trim()==='')){
    return false;
  }
  return true;
}
/**
 * author:langwenqi
 * date: 2018/5/20
 * describe:验证手机号
 * params:{
  *
  * }
 **/
export function checkMobile (mobile) {
  let reg = /^1[0-9]{10}$/;
  return reg.test(mobile)
};

//富文本
export function getEditHtml(str) {
  if(!str){
    return;
  }
  return str.replace(/<img/g,"<img style=\'width:100%\' data=\'detailImg\'")
}

//找到对象摸个属性并删除
export function deleteObjPrototype(obj={},p) {
  console.log(obj)
  console.log(p)
  console.log(obj[p])
  if (!obj[p]) return obj;
  delete obj[p];
  console.log(obj)
  return obj;
}
//提取html图片src
export function getHtmlImg(strs){
  let imgReg = /<img.*?(?:>|\/>)/gi;
  let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
  let arr =[];
  if(strs&&strs.trim()){
    arr = strs.match(imgReg);
  }
  console.log('所有已成功匹配图片的数组：'+arr);
  let arr_src = [];
  if(arr){
    for (var i = 0; i < arr.length; i++) {
      var src = arr[i].match(srcReg);
      //获取图片地址
      if(src[1]){
        arr_src.push(src[1])
      }
    }
  }
  console.log('截取html生成的数组')
  console.log(arr_src)
  return arr_src;
}

//显示放大图
export function preverImg(index=0,imgUrl=[]) {
  console.log('传入显示的大图数组')
  console.log(imgUrl)
  wx.previewImage({
    current:imgUrl[index], // 当前显示图片的http链接
    urls: imgUrl // 需要预览的图片http链接列表
  })
}

//判断是否为iphone X
export function isIPhoneX(){
  var u = navigator.userAgent;
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isIOS) {
    if (screen.height == 812 && screen.width == 375){
      //是iphoneX
      return true;
    }else{
      //不是iphoneX
      return false;
    }
  }
}
//无头像获取默认头像
export function getDefaultImg(url) {
  return url?url:TokenKeys.DEFAULT_USER_PHOTO;
}

//计算字符串字节数
export function getBytesLength(str) {
  // 在GBK编码里，除了ASCII字符，其它都占两个字符宽
  return str.replace(/[^\x00-\xff]/g, 'xx').length;
}

//
export function getStr(str,len,ellipsis=false) {
    if(!str)return ''
    var regexp = /[^\x00-\xff]/g;// 正在表达式匹配中文
    // 当字符串字节长度小于指定的字节长度时
    if (str.replace(regexp, "aa").length <= len) {
      return str;
    }
    // 假设指定长度内都是中文
    var m = Math.floor(len/2);
    for (var i = m, j = str.length; i < j; i++) {
      // 当截取字符串字节长度满足指定的字节长度
      if (str.substring(0, i).replace(regexp, "aa").length >= len) {
        if(!ellipsis){
          return str.substring(0, i) +'...';
        }else{
          return str.substring(0, i);
        }
      }
    }
    return str;
}
//弹窗
export const showToast = (that,text,type='correct',mask=true,time=2000)=>{
  return that.$createToast({
    time: time,
    mask:mask,
    txt: text,
    type:type
  })
}
export function makeFileObj(type, file, endType) {
  let content = {};
  content.type = type;
  content.fileName = file.name;
  content.endType = endType;
  return content;
};
export function handleKey(file) {
  if (!file) {
    return {}
  }
  if (file.type.split('/')[0] == 'image') {
    return makeFileObj(1, file, file.type.split('/')[1]);
  } else if (file.type.split('/')[0] == 'video') {
    return makeFileObj(3, file, file.type.split('/')[1]);
  } else if (file.type.split('/')[1] == 'msword') {
    return makeFileObj(5, file, 'doc');
  } else if (file.type.split('/')[1] == 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
    return makeFileObj(5, file, 'docx');
  } else if (file.type.split('/')[1] == 'vnd.ms-excel') {
    return makeFileObj(7, file, 'xls');
  } else if (file.type.split('/')[1] == 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    return makeFileObj(7, file, 'xlsx');
  } else if (file.type.split('/')[1] == 'vnd.ms-powerpoint') {
    return makeFileObj(8, file, 'ppt');
  } else if (file.type.split('/')[1] == 'vnd.openxmlformats-officedocument.presentationml.presentation') {
    return makeFileObj(8, file, 'pptx');
  } else if (file.type.split('/')[1] == 'pdf') {
    return makeFileObj(6, file, 'pdf');
  } else if (file.type.split('/')[1] == 'plain') {
    return makeFileObj(4, file, 'txt')
  } else if (file.type.split('/')[0] == 'audio') {
    return makeFileObj(9, file, file.type.split('/')[1]);
  } else {
    return makeFileObj(127, file, file.type.split('/')[1]);
  }
};

//oss图片处理
export function comPressFile(url){
  return `${url}?x-oss-process=image/format,jpg/resize,w_400/auto-orient,1`
  // return `${url}?x-oss-process=image/format,jpg/quality,q_80/resize,w_400`
}
//限制只能输入中文英文数字
export function changeTxt(txt) {
  return txt.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g,'')
}




// WEBPACK FOOTER //
// ./src/common/js/util.js